import abimg from '../assets/svg/about/aboutimage.png'


export const aboutData = {
    title: "Who I am",
    description1: "Hello! My name is Simrat Singh, I'm an aspiring Full Stack MERN developer based in India.",
    description2: "I completed Bachelor's degree in Computer Science, currently working as a Full Stack Web Developer. I am passionate about the entire software development lifecycle, from designing and coding to debugging and testing websites and mobile apps. With a strong foundation in C++, Java, and Python, I possess excellent problem-solving skills. Furthermore, I am actively expanding my skill set, delving into areas like AI, ML, Data Science, the Metaverse, and Crypto Mining to stay at the forefront of technological advancements.",
    image: abimg,
    
}

